var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Modal } from '@doordash/component-modal';
import { useToast } from '@doordash/component-toast';
import { Icon, Inset } from '@doordash/design-language';
import { unwrapResult } from '@reduxjs/toolkit';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { addTeamAccountGroupHook } from '../groups_slice';
import GroupForm from './group_form';
import track from '../../../utils/track';
import { GroupsEvents } from '../../../constants/events';
export var CreateGroupModal = function (_a) {
    var teamAccountId = _a.teamAccountId, onGroupCreated = _a.onGroupCreated, onClose = _a.onClose, group = _a.group;
    var dispatch = useDispatch();
    var displayToast = useToast().displayToast;
    var _b = __read(React.useState({}), 2), formResponse = _b[0], setFormResponse = _b[1];
    var handleFormSubmit = function (values, actions) {
        var groupOptions = {
            teamAccountId: teamAccountId,
            name: values.name,
            description: values.description,
            groupId: group === null || group === void 0 ? void 0 : group.id,
        };
        dispatch(addTeamAccountGroupHook(groupOptions))
            .then(unwrapResult)
            .then(function (data) {
            track(group
                ? GroupsEvents.SUBMIT_EDIT_GROUP
                : GroupsEvents.SUBMIT_ADD_GROUP, {
                name: groupOptions.name,
                description: groupOptions.description,
            });
            displayToast({
                icon: Icon.Types.Check,
                text: group
                    ? 'Group updated successfully'
                    : 'Group added successfully',
                insetFromEdge: Inset.Sizes.XxxLarge,
            });
            onGroupCreated(data.teamAccountGroup.id);
            onClose();
        }, function (errorResponse) {
            if (errorResponse.error === 'DUPLICATE_GROUP_NAME') {
                actions.setFieldError('name', 'Group name already exists. Try another name to proceed.');
            }
            else {
                setFormResponse({
                    response: {
                        success: false,
                        errorMessage: errorResponse.error || 'There was an error.',
                    },
                });
            }
        })
            .finally(function () {
            actions.setSubmitting(false);
        });
    };
    return (React.createElement(Modal, { onClose: onClose, title: Boolean(group) ? 'Edit Group' : 'Create New Group' },
        React.createElement(GroupForm, { group: group, handleFormSubmit: handleFormSubmit, submitResponse: formResponse, onClose: onClose })));
};
export default CreateGroupModal;
